import { render, staticRenderFns } from "./BetDetailComponent.vue?vue&type=template&id=2334cf46"
import script from "./BetDetailComponent.vue?vue&type=script&lang=js"
export * from "./BetDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./BetDetailComponent.vue?vue&type=style&index=0&id=2334cf46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports